// Quantities with their units, the mock's unitQ(): "2 trays (60 eggs)" for a line sold in a sale unit, "60 eggs" otherwise. Quantities on dispatch
// slips and order lines are BASE units; the sale unit is a display stamp (sale_unit_label / sale_unit_ratio).
// Sums NEVER add unlike units: unitGroups() buckets by the unit shown.

const num = v => { const x = Number(v); return Number.isFinite(x) ? x : 0; };
const real = u => (u ? String(u) : '');   // the item's own unit label, as set in Items settings (even the generic 'unit')
export const baseUnit = l => real(l.base_unit_label) || real(l.item_unit);
export const saleUnit = l => (real(l.sale_unit_label) && num(l.sale_unit_ratio) > 1 ? { label: l.sale_unit_label, ratio: num(l.sale_unit_ratio) } : null);

// -> { main: '2 trays', base: '60 eggs' | null } ; falls back to the base unit when the quantity is not a whole number of sale units
export function qtyParts(q, l, fmt = String) {
  const b = baseUnit(l), s = saleUnit(l), n = num(q);
  if (s && n > 0 && Math.abs(n / s.ratio - Math.round(n / s.ratio)) < 1e-9) return { main: `${fmt(Math.round(n / s.ratio))} ${s.label}`, base: `${fmt(n)}${b ? ` ${b}` : ''}`, unit: s.label, amount: Math.round(n / s.ratio) };
  return { main: `${fmt(n)}${b ? ` ${b}` : ''}`, base: null, unit: b, amount: n };
}
export const qtyText = (q, l, fmt = String) => { const p = qtyParts(q, l, fmt); return p.base ? `${p.main} (${p.base})` : p.main; };

// rows of { qty, line } -> [{ unit, amount }] summed per displayed unit, first-seen order (the totals row / KPI "300 eggs · 4 birds")
export function unitGroups(entries, fmt = String) {
  const by = new Map();
  for (const { qty, line } of entries) {
    const p = qtyParts(qty, line, fmt);
    by.set(p.unit, Math.round(((by.get(p.unit) || 0) + p.amount) * 1000) / 1000);
  }
  return [...by].map(([unit, amount]) => ({ unit, amount }));
}
export const groupsText = (groups, fmt = String) => groups.map(g => `${fmt(g.amount)}${g.unit ? ` ${g.unit}` : ''}`).join(' · ') || '—';
